import { useEffect, useState, FC } from 'react';

interface HeroVideoProps {
  className?: string;
}

const HeroVideo: FC<HeroVideoProps> = ({ className = '' }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const video = document.createElement('video');
    video.src = '/assets/hero-bg.mp4';
    video.preload = 'auto';
    
    video.onloadeddata = () => {
      setIsLoaded(true);
    };

    return () => {
      video.onloadeddata = null;
    };
  }, []);

  if (!isLoaded) {
    return null;
  }

  return (
    <video 
      autoPlay 
      muted 
      loop 
      playsInline 
      className={`absolute inset-0 w-full h-full object-cover opacity-20 ${className}`}
    >
      <source src="/assets/hero-bg.mp4" type="video/mp4" />
    </video>
  );
};

export default HeroVideo; 